import React from "react";

const genieHappy = "/genie.png";
const genieSad = "/genie-offline.png";

const NoDataMessage = ({ type }) => {
  const isSad = type === "online";

  const getMessage = () => {
    switch (type) {
      case "offline":
        return "No devices are currently offline — your wish is granted!";
      case "alerts":
        return "No voltage alerts detected — your wish is granted!";
      case "outages":
        return "No outages detected — your wish is granted!";
      case "online":
        return "Genie’s listening… but the devices aren’t talking.";
      default:
        return "No blinks detected — your wish is granted!";
    }
  };

  const imgSrc = isSad ? genieSad : genieHappy;

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "4rem",
        background: "#f4f4f4",
        padding: "2rem",
        borderRadius: "10px",
      }}
    >
      <img
        src={imgSrc}
        alt="Meter Genie"
        style={{ width: "200px", marginBottom: isSad ? "0" : "1rem" }}
      />
      {!isSad && <h3>{getMessage()}</h3>}
    </div>
  );
};

export default NoDataMessage;
